import { useId } from "react";

import { useDialogFocus } from "../../app/useDialogFocus";

export function ResourceRoomDialog({
  title,
  description,
  onClose,
  busy = false,
  wide = false,
  children
}: {
  title: string;
  description?: string;
  onClose: () => void;
  busy?: boolean;
  wide?: boolean;
  children: React.ReactNode;
}): React.JSX.Element {
  const titleId = useId();
  const descriptionId = useId();
  const dialogRef = useDialogFocus(onClose, !busy);

  return (
    <div
      className="modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (!busy && event.target === event.currentTarget) onClose();
      }}
    >
      <section
        ref={dialogRef}
        className={`modal-card resource-room-dialog${wide ? " wide" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={description ? descriptionId : undefined}
      >
        <div className="resource-dialog-heading">
          <div>
            <h2 id={titleId}>{title}</h2>
            {description ? <p id={descriptionId}>{description}</p> : null}
          </div>
          <button
            className="dialog-close"
            type="button"
            aria-label={`关闭${title}`}
            disabled={busy}
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <div className="resource-dialog-body">{children}</div>
      </section>
    </div>
  );
}
